import React from 'react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function Hero() {
  return <section className="pt-8 pb-6 px-4 sm:px-6 bg-white text-center border-b-4 border-brand-gray" data-id="element-88">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-pool/10 border border-brand-pool/30 text-brand-navy font-bold text-xs sm:text-sm mb-3 shadow-sm" data-id="element-89">
        <span data-id="element-90">🏊</span>
        <span className="tracking-wide uppercase" data-id="element-91">SWIMMING COACH READY™</span>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading font-black text-brand-navy leading-tight mb-3" data-id="element-92">
        The Complete Planning System for Swim Instructors
      </h1>

      <p className="text-base sm:text-lg text-brand-navy/80 font-medium leading-snug mb-5 max-w-2xl mx-auto" data-id="element-93">
        Save hours of planning, deliver better lessons, and coach with
        confidence — without creating classes from scratch.
      </p>

      <div className="mb-5" data-id="element-94">
        <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/aTXo3ByxQ5iocpXC8cAKKr/ChatGPT-Image-17-jun-2026_-06_41_45-p.m..webp" alt="Swimming Coach Ready 6-in-1 Box Set" className="w-full h-auto object-contain max-w-[320px] sm:max-w-md mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-xl" data-id="element-96" />
        </a>
      </div>

      <div className="mb-4" data-id="element-97">
        <CTAButton data-id="element-98">🚀 YES, I WANT MY SYSTEM NOW</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-xs sm:text-sm text-brand-navy font-bold" data-id="element-99">
        <div className="flex items-center gap-1.5" data-id="element-100">
          <Star className="w-4 h-4 fill-brand-orange text-brand-orange" data-id="element-101" />
          <span data-id="element-102">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-103">
          <Shield className="w-4 h-4 text-brand-pool" data-id="element-104" />
          <span data-id="element-105">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}